import {GlobalStyles} from '@mui/material';
import React from 'react';

const styles = theme => ({
  'html, body': {
    fontFamily: theme.typography.fontFamily,
    height: '100%',
  },
  '#pl-root': {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    height: '100%',
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  },
  // style for shift-drag-zoom
  '.ol-box': {
    background: theme.vars.palette.common.white,
    border: `1px dashed ${theme.vars.palette.primary.dark}`,
    boxSizing: 'border-box',
    opacity: 0.4,
  },
  a: {
    cursor: 'pointer',
  },
  img: {
    userDrag: 'none',
  },
  '.sentry-error-embed-wrapper': {
    '& .btn': {
      background: `${theme.vars.palette.primary.main} !important`,
      border: `1px solid ${theme.vars.palette.primary.main} !important`,
      borderRadius: theme.shape.borderRadius,
    },
  },
});

const appGlobalStyles = <GlobalStyles styles={styles} />;

export default appGlobalStyles;
